import { SplitApiSettings } from "./SplitApiSetting";
import { API_END_POINTS } from "./ApiEndpoints";

export const api = SplitApiSettings.injectEndpoints({
  reducerPath: "api",
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    /////////////////////////////<===MUTATIONS===>//////////////////////////////
    registerUser: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.registerUser,
        method: "POST",
        body: data,
      }),
    }),

    registerWithInvitation: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.registerWithInvitation,
        method: "POST",
        body: data,
      }),
    }),

    loginUser: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.loginUser,
        method: "POST",
        body: data,
      }),
    }),

    socialLogin: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.socialLogin,
        method: "POST",
        body: data,
      }),
    }),

    forgotPassword: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.forgotPassword,
        method: "POST",
        body: data,
      }),
    }),

    resetPassword: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.resetPassword,
        method: "POST",
        body: data,
      }),
    }),

    changePassword: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.changePassword,
        method: "POST",
        body: data,
      }),
    }),

    signupBasic: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.signupBasic,
        method: "POST",
        body: data,
      }),
    }),

    signupPost: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.signupPost,
        method: "POST",
        body: data,
      }),
    }),

    signupPackages: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.signupPackages,
        method: "POST",
        body: data,
      }),
    }),

    editPackages: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.editPackages,
        method: "POST",
        body: data,
      }),
    }),

    addChallange: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addChallange,
        method: "POST",
        body: data,
      }),
    }),

    messageMedia: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.messageMedia,
        method: "POST",
        body: data,
      }),
    }),

    userProfilPic: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.userProfilPic,
        method: "POST",
        body: data,
      }),
    }),

    addPitch: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addPitch,
        method: "POST",
        body: data,
      }),
    }),

    submitPitchContent: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.submitPitchContent,
        method: "POST",
        body: data,
      }),
    }),

    directHire: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.directHire,
        method: "POST",
        body: data,
      }),
    }),

    decideJobOffer: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.decideJobOffer,
        method: "POST",
        body: data,
      }),
    }),

    submitFeedback: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.submitFeedback,
        method: "POST",
        body: data,
      }),
    }),

    saveInfluencer: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.saveInfluencer,
        method: "POST",
        body: data,
      }),
    }),

    addList: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addList,
        method: "POST",
        body: data,
      }),
    }),

    sendEmail: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.sendEmail,
        method: "POST",
        body: data,
      }),
    }),

    replyToEmail: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.replyToEmail,
        method: "POST",
        body: data,
      }),
    }),

    seenNotification: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.seenNotification,
        method: "POST",
        body: data,
      }),
    }),

    deleteList: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.deleteList,
        method: "POST",
        body: data,
      }),
    }),

    editChallange: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.editChallange,
        method: "POST",
        body: data,
      }),
    }),

    contactUs: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.contactUs,
        method: "POST",
        body: data,
      }),
    }),

    submitProfileForApproval: builder.mutation({
      query: () => ({
        url: API_END_POINTS.submitProfileForApproval,
        method: "POST",
      }),
    }),

    removeInvite: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.removeInvite,
        method: "POST",
        body: data,
      }),
    }),

    addBankAccount: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.addBankAccount,
        method: "POST",
        body: data,
      }),
    }),

    makePayment: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.makePayment,
        method: "POST",
        body: data,
      }),
    }),

    releasePayment: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.releasePayment,
        method: "POST",
        body: data,
      }),
    }),

    saveCard: builder.mutation({
      query: ({ data }) => ({
        url: API_END_POINTS.saveCard,
        method: "POST",
        body: data,
      }),
    }),

    deleteAccount: builder.mutation({
      query: () => ({
        url: API_END_POINTS.deleteAccount,
        method: "POST",
      }),
    }),

    /////////////////////////////<===QUERIES===>////////////////////////////////

    getPackages: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getPackages,
          method: "GET",
        };
      },
    }),

    getInfluencerProfile: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getInfluencerProfile,
          method: "GET",
        };
      },
    }),

    getInfluencers: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getInfluencers,
          method: "GET",
          params,
        };
      },
    }),

    getInfluencersHome: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getInfluencersHome,
          method: "GET",
          params
        };
      },
    }),

    getChallanges: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getChallanges,
          method: "GET",
          params
        };
      },
    }),

    getChallangeDetail: builder.query({
      query: ({ id }) => {
        return {
          url: `${API_END_POINTS.getChallangeDetail}/${id}`,
          method: "GET",
        };
      },
    }),

    getBrandChallanges: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getBrandChallanges,
          method: "GET",
          params,
        };
      },
    }),

    getCategories: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getCategories,
          method: "GET",
        };
      },
    }),

    getChallangeProposals: builder.query({
      query: ({ id }) => {
        return {
          url: `${API_END_POINTS.getChallangeProposals}/${id}`,
          method: "GET",
        };
      },
    }),

    getInfluencerChallanges: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getInfluencerChallanges,
          method: "GET",
          params
        };
      },
    }),

    getInfluencerJobs: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getInfluencerJobs,
          method: "GET",
          params
        };
      },
    }),

    getInfluencerDashboard: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getInfluencerDashboard,
          method: "GET",
        };
      },
    }),

    getJobOffers: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getJobOffers,
          method: "GET",
          params,
        };
      },
    }),

    getSubmittedContents: builder.query({
      query: ({ challengeId }) => {
        return {
          url: `${API_END_POINTS.getSubmittedContents}/${challengeId}`,
          method: "GET",
        };
      },
    }),

    savedInfluencers: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.savedInfluencers,
          method: "GET",
        };
      },
    }),

    getList: builder.query({
      query: ({ params }) => {
        return {
          url: `${API_END_POINTS.getList}/${params?.listId}`,
          method: "GET",
          params,
        };
      },
    }),

    getListProspects: builder.query({
      query: ({ params }) => {
        return {
          url: `${API_END_POINTS.getListProspects}/${params?.listId}`,
          method: "GET",
          params,
        };
      },
    }),

    getListOutreached: builder.query({
      query: ({ params }) => {
        return {
          url: `${API_END_POINTS.getListOutreached}/${params?.listId}`,
          method: "GET",
          params,
        };
      },
    }),

    getReports: builder.query({
      query: ({ id, type }) => {
        return {
          url: `${API_END_POINTS.getReports}/${id}/${type}`,
          method: "GET",
        };
      },
    }),

    getNotifications: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getNotifications,
          method: "GET",
        };
      },
    }),

    fetchLatestCounts: builder.query({
      query: ({ challengeId, pitchId }) => {
        return {
          url: `${API_END_POINTS.fetchLatestCounts}/${challengeId}/${pitchId}`,
          method: "GET",
        };
      },
    }),

    getEmail: builder.query({
      query: ({ inboxId }) => {
        return {
          url: `${API_END_POINTS.getEmail}/${inboxId}`,
          method: "GET",
        };
      },
    }),

    getHiredInfluencers: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getHiredInfluencers,
          method: "GET",
        };
      },
    }),

    getDashboard: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getDashboard,
          method: "GET",
        };
      },
    }),

    getUserWithInvitation: builder.query({
      query: ({ invitationcode }) => {
        return {
          url: `${API_END_POINTS.getUserWithInvitation}/${invitationcode}`,
          method: "GET",
        };
      },
    }),

    influencerMainSearch: builder.query({
      query: ({ name }) => {
        return {
          url: `${API_END_POINTS.influencerMainSearch}/${name}`,
          method: "GET",
        };
      },
    }),

    influencerProfile: builder.query({
      query: ({ userId }) => {
        return {
          url: `${API_END_POINTS.influencerProfile}/${userId}`,
          method: "GET",
        };
      },
    }),

    getInfluencersFromRapid: builder.query({
      query: ({ params }) => {
        return {
          url: API_END_POINTS.getInfluencersFromRapid,
          method: "GET",
          params,
          headers: {
            'x-rapidapi-key': '6bdecf4451mshcd89b0d7761e516p1abce5jsn51cf45f10fc3',
            'x-rapidapi-host': 'instagram-statistics-api.p.rapidapi.com'
          }
        };
      },
    }),

    getHome: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getHome,
          method: "GET",
        };
      },
    }),

    getCreator: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getCreator,
          method: "GET",
        };
      },
    }),

    getPrivacy: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getPrivacy,
          method: "GET",
        };
      },
    }),

    getTerms: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getTerms,
          method: "GET",
        };
      },
    }),

    getAbout: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getAbout,
          method: "GET",
        };
      },
    }),

    getSettings: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getSettings,
          method: "GET",
        };
      },
    }),

    getChallengesDropdown: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getChallengesDropdown,
          method: "GET",
        };
      },
    }),

    getInvitedJobs: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getInvitedJobs,
          method: "GET",
        };
      },
    }),

    getBrandTransactions: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getBrandTransactions,
          method: "GET",
        };
      },
    }),

    getInfluencerTransactions: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getInfluencerTransactions,
          method: "GET",
        };
      },
    }),

    getInfluencerLeaderboard: builder.query({
      query: ({ id }) => {
        return {
          url: `${API_END_POINTS.getInfluencerLeaderboard}/${id}`,
          method: "GET",
        };
      },
    }),

    getBrandTransactionChallange: builder.query({
      query: ({ id }) => {
        return {
          url: `${API_END_POINTS.getBrandTransactionChallange}/${id}`,
          method: "GET",
        };
      },
    }),

    getBrandTransactionJobs: builder.query({
      query: ({ id }) => {
        return {
          url: `${API_END_POINTS.getBrandTransactionJobs}/${id}`,
          method: "GET",
        };
      },
    }),

    getAllCards: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getAllCards,
          method: "GET",
        };
      },
    }),

    getInfDashboardChallange: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getInfDashboardChallange,
          method: "GET",
        };
      },
    }),

    getInfDashboardJob: builder.query({
      query: () => {
        return {
          url: API_END_POINTS.getInfDashboardJob,
          method: "GET",
        };
      },
    }),

  }),

  overrideExisting: true,
});

export const {
  /////////////////////////////<===MUTATIONS===>//////////////////////////////
  useRegisterUserMutation,
  useRegisterWithInvitationMutation,
  useLoginUserMutation,
  useSocialLoginMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useSignupBasicMutation,
  useSignupPostMutation,
  useSignupPackagesMutation,
  useEditPackagesMutation,
  useAddChallangeMutation,
  useMessageMediaMutation,
  useUserProfilPicMutation,
  useAddPitchMutation,
  useSubmitPitchContentMutation,
  useDirectHireMutation,
  useDecideJobOfferMutation,
  useSubmitFeedbackMutation,
  useSaveInfluencerMutation,
  useAddListMutation,
  useSendEmailMutation,
  useReplyToEmailMutation,
  useSeenNotificationMutation,
  useDeleteListMutation,
  useEditChallangeMutation,
  useContactUsMutation,
  useSubmitProfileForApprovalMutation,
  useRemoveInviteMutation,
  useAddBankAccountMutation,
  useMakePaymentMutation,
  useReleasePaymentMutation,
  useSaveCardMutation,
  useDeleteAccountMutation,
  /////////////////////////////<===QUERIES===>////////////////////////////////
  useGetPackagesQuery,
  useGetInfluencerProfileQuery,
  useGetInfluencersQuery,
  useGetInfluencersHomeQuery,
  useGetChallangesQuery,
  useGetChallangeDetailQuery,
  useGetBrandChallangesQuery,
  useGetCategoriesQuery,
  useGetChallangeProposalsQuery,
  useGetInfluencerChallangesQuery,
  useGetInfluencerJobsQuery,
  useGetInfluencerDashboardQuery,
  useGetJobOffersQuery,
  useGetSubmittedContentsQuery,
  useSavedInfluencersQuery,
  useGetListQuery,
  useGetListProspectsQuery,
  useGetListOutreachedQuery,
  useGetReportsQuery,
  useGetNotificationsQuery,
  useFetchLatestCountsQuery,
  useGetInfluencersFromRapidQuery,
  useGetEmailQuery,
  useGetHiredInfluencersQuery,
  useGetDashboardQuery,
  useGetUserWithInvitationQuery,
  useInfluencerMainSearchQuery,
  useInfluencerProfileQuery,
  useGetHomeQuery,
  useGetCreatorQuery,
  useGetPrivacyQuery,
  useGetTermsQuery,
  useGetAboutQuery,
  useGetSettingsQuery,
  useGetChallengesDropdownQuery,
  useGetInvitedJobsQuery,
  useGetBrandTransactionsQuery,
  useGetInfluencerTransactionsQuery,
  useGetInfluencerLeaderboardQuery,
  useGetBrandTransactionChallangeQuery,
  useGetBrandTransactionJobsQuery,
  useGetAllCardsQuery,
  useGetInfDashboardChallangeQuery,
  useGetInfDashboardJobQuery,
} = api;
